import React, { CSSProperties } from 'react';
import { FormattedMessage } from 'react-intl';

interface TitleH4Props {
  textId: string;
  center?: boolean;
  textTransform?:
    | 'none'
    | 'capitalize'
    | 'uppercase'
    | 'lowercase'
    | 'full-width'
    | 'full-size-kana'
    | undefined;
  style?: CSSProperties;
}

/**
 * Componente "tonto" para mostrar tablas en catálogos
 * Props:
 *  textId:
 *    El id del texto a traducir
 */
const TitleH4: React.FC<TitleH4Props> = ({
  textId,
  center = false,
  textTransform = 'none',
  style = {}
}) => (
  <h4
    style={{
      textAlign: center ? 'center' : undefined,
      textTransform: textTransform,
      ...style
    }}
  >
    <FormattedMessage id={textId} />
  </h4>
);

export default TitleH4;
